import {
  DRAWER_ID_FOLDERS_CHANNELS_MAIL_IMPORT,
  DRAWER_ID_FOLDERS_CHANNELS_EMAIL_FORWARD,
  DRAWER_ID_FOLDERS_CHANNELS_CREATION_FEEDBACK,
} from 'ducks/drawers/ids'
import {
  DRAWER_TYPE_CHANNELS_MAIL_IMPORT,
  DRAWER_TYPE_CHANNELS_EMAIL_FORWARD,
  DRAWER_TYPE_CHANNELS_CREATION_FEEDBACK,
} from 'ducks/drawers/types'

export default {
  gmail: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_MAIL_IMPORT,
      type: DRAWER_TYPE_CHANNELS_MAIL_IMPORT,
      closeIgnoresStack: true,
    },
  },
  messenger: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_CREATION_FEEDBACK,
      type: DRAWER_TYPE_CHANNELS_CREATION_FEEDBACK,
      closeIgnoresStack: true,
    },
  },
  forwarding: {
    drawer: {
      id: DRAWER_ID_FOLDERS_CHANNELS_EMAIL_FORWARD,
      type: DRAWER_TYPE_CHANNELS_EMAIL_FORWARD,
      closeIgnoresStack: true,
    },
  },
}
